import { render, staticRenderFns } from "./CliDASelfService.vue?vue&type=template&id=78da3afc"
import script from "./CliDASelfService.vue?vue&type=script&lang=js"
export * from "./CliDASelfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports